
 function addFormDonationListeners(){
  let bh_donation_form = document.querySelector('#bh_donation_form');
   
   if(bh_donation_form){
  bh_donation_form.addEventListener('change',function(e){e.stopPropagation();return false;});
  bh_donation_form.addEventListener('click',function(e){e.stopPropagation();return false;});
   }
 }  
  let items_in_cart=[]



async function getCartItems(){
    
    const cart = await fetch('/cart.js').then(response=> response.json()).then( function(data){   items_in_cart = data.items } ) ;
    
}

// async function checkDonationInCart(){
//     let donation_in_cart = false;
//     const donation_items = items_in_cart.filter(item => item.id === 13387323506799);
//     if( donation_items.length > 0 ){

//         donation_in_cart = true;
//     }

//     return donation_in_cart
// }



// async function modifyDonationInCart(quantity=1){

// const response = await fetch('/cart/update.js', {
//     method: 'POST',
//     headers: {
//       'Accept': 'application/json',
//       'Content-Type': 'application/json'
//     },
//     body: JSON.stringify({

//         updates: {
//             13387323506799: quantity
            
//         }
//     })});
// const cart = await response.json();

        
        

// }

  
function addCheckoutEventListener(){    
  
console.log('checkout event listener added');
        
        let checkout_button = document.querySelector('button[name="checkout"]');
        checkout_button.addEventListener('click', async function (e){
        console.log('Clicked the checkout button');
          
        e.preventDefault();   
        console.log('Prevented Default');
        let checkout_button = e.currentTarget;
        checkout_button.setAttribute('disabled',true);
        
          
          let donation_status = false;
          let donation_input = document.querySelector('input[name="bh_donation"]');
          
          // if(donation_input){ 
          //   donation_status= donation_input.checked;
          // }
        
        
          // if(!donation_status)
          // {
      
          //   try{
          //    await modifyDonationInCart(0);
          //   }catch(e){
          //     console.log('there was an error');
          //     console.error(e);
          //   }
              
          // }
          // else{
              
              
              
          //     await getCartItems();
              
          //     let donation_is_in_cart = await checkDonationInCart().then(x => x);
              
          //      if(!donation_is_in_cart){
              
          //       await modifyDonationInCart();
                   
          //      }
             
          // }
        try{
          console.log('trying modifying shipping');
          await modifyShippingProtection();
        }catch(e){
          console.error(e);
        }
          
    checkout_button.removeAttribute('disabled');
    window.location.href= '/checkout';
    return false;
    });

}

  function ready(fn) {
  if (document.readyState != 'loading'){
    fn();
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
}
  
  
ready(addCheckoutEventListener);
ready(addFormDonationListeners);
cartRedrawCallbackStack.push(addCheckoutEventListener);
cartRedrawCallbackStack.push(addFormDonationListeners);

